/* This Source Code Form is subject to the terms of the Mozilla Public
 * License, v. 2.0. If a copy of the MPL was not distributed with this
 * file, You can obtain one at https://mozilla.org/MPL/2.0/. */

import ByteOrder from './byte-order.js';
import {TIFF_ID, TIFF_ID_OFFSET} from './tiff-constants.js';

export default {
    isTiffFile,
    findTiffOffsets
};

function isTiffFile(dataView) {
    const MIN_TIFF_DATA_BUFFER_LENGTH = 4;

    return !!dataView && (dataView.byteLength >= MIN_TIFF_DATA_BUFFER_LENGTH) && hasTiffMarker(dataView);
}

function hasTiffMarker(dataView) {
    const littleEndian = dataView.getUint16(0) === ByteOrder.LITTLE_ENDIAN;
    return dataView.getUint16(TIFF_ID_OFFSET, littleEndian) === TIFF_ID;
}

/**
 * A TIFF file is its own Exif block: the TIFF header sits at offset 0. There
 * is no container around it, so no range is recorded.
 *
 * @returns {Array<Object>} One exif block.
 */
function findTiffOffsets() {
    const TIFF_FILE_HEADER_OFFSET = 0;

    return [{kind: 'exif', tiffHeaderOffset: TIFF_FILE_HEADER_OFFSET}];
}
